import { LambdaAdmin } from "../../common/services/http-service"

const useLookup = () => {

    const getUsuariosSoporte = async (todos = false) => {
        try {
            return await LambdaAdmin({ resource: `soporte/ticket/usuarios?todos=${todos}`, method: "GET", });
        } catch (error) {
            return null
        }
    };

    const getTicketStatus = async () => {
        try {
            return await LambdaAdmin({ resource: `soporte/ticket/lookup/status`, method: "GET", });
        } catch (error) {
            return null
        }
    };

    const getStatesByCountry = async (PaisID) => {
        try {
            return await LambdaAdmin({ resource: `soporte/ticket/lookup/estados?PaisID=${PaisID}`, method: "GET", });
        } catch (error) {
            return null
        }
    };
    
    const getPlataformas = async () => {
        try {
            return await LambdaAdmin({ resource: `soporte/ticket/lookup/dispositivos`, method: "GET", });
        } catch (error) {
            return null
        }
    };

    const getTicketReason = async () => {
        try {
            return await LambdaAdmin({ resource: `soporte/ticket/lookup/motivo`, method: "GET", });
        } catch (error) {
            return null
        }
    };

    const getTicketMedium = async () => {
        try {
            return await LambdaAdmin({ resource: `soporte/ticket/lookup/medio`, method: "GET", });
        } catch (error) {
            return null
        }
    };

    const getPayrollsStatus = () => {
        const status = [
            { statusId: 0, statusDesc: "Todos los estatus" },
            { statusId: 4, statusDesc: "Timbrado" },
            { statusId: 5, statusDesc: "Cancelado" },
        ];

        return { exitoso: true, data: status };
    };

    const getCloseMotTicket = async () => {
        try {
            return await LambdaAdmin({ resource: `soporte/ticket/lookup/cierre`, method: "GET", });
        } catch (error) {
            return null
        }
    };

    return {
        getUsuariosSoporte,
        getTicketStatus,
        getStatesByCountry,
        getPlataformas,
        getTicketReason,
        getTicketMedium,
        getPayrollsStatus,
        getCloseMotTicket
    };
};

export default useLookup;